/**
 * Author: postcodex
 * Date: 10/5/20
 * Time: 5:31 PM
 */

export const
APP_PROP_CHANGE          = 'APP_PROP_CHANGE',

SEARCH_ADDRESSES         = 'SEARCH_ADDRESSES',
SEARCH_ADDRESSES_SUCCESS = 'SEARCH_ADDRESSES_SUCCESS',
SEARCH_ADDRESSES_ERROR   = 'SEARCH_ADDRESSES_ERROR',

searchAddresses          = ( payload ) => {
	return { type : SEARCH_ADDRESSES, payload };
},

appPropChange            = ( payload ) => {
	return { type : APP_PROP_CHANGE, payload };
};
